/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_please_visit_the_account_page_to_check_payment_method: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Please visit the account page to check your payment method or add a new one`,
    es: `Visite la página de cuenta para confirmar tu método de pago o añadir uno neuvo método de pago`,
  };
  return phrases[locale] || phrases.en || `please_visit_the_account_page_to_check_payment_method`;
};
